module.exports = "/assets/data/46af7f7447c7007faebe7808ad6992cf-CB24.data.json";